/** A type tile starts a fresh browse listing; API toggle URLs retain other filters. */
export type TypeFilterStripSource = 'plp' | 'homepage';

export function getTypeFilterStripUrl(typeName?: string, source: TypeFilterStripSource = 'plp'): string {
  if (!typeName?.trim()) return source === 'homepage' ? '/' : '/jewellery.html';
  const normalizedTypeName = typeName.trim().toLowerCase().replace(/\+/g, ' ').replace(/\s+/g, ' ');
  const tag = normalizedTypeName === 'nose accessory' ? 'nose pins' : normalizedTypeName;
  if (source === 'homepage') return `/?filters=${encodeURIComponent(tag).replace(/%20/g, '+')}`;
  return `/jewellery/${encodeURIComponent(tag).replace(/%20/g, '+')}.html`;
}
